export default {
  above: 'above',
  inside: 'inside',
  below: 'below',
  invisible: 'invisible',
};



// WEBPACK FOOTER //
// ./src/constants.js